import {
  faAngleRight as proFasFaAngleRight,
  faBan as proFasFaBan,
  faCheck as proFasFaCheck,
  faChevronDown as proFasFaChevronDown,
  faChevronRight as proFasFaChevronRight,
  faCircleCheck as proFasFaCircleCheck,
  faCircleExclamation as proFasFaCircleExclamation,
  faCircleInfo as proFasFaCircleInfo,
  faCircleX as proFasFaCircleX,
  faCircleXmark as proFasFaCircleXmark,
  faCircle as proFasFaCircle,
  faDownLong as proFasFaDownLong,
  faEllipsisVertical as proFasFaEllipsisVertical,
  faFileContract as proFasFaFileContract,
  faHourglassClock as proFasFaHourglassClock,
  faHourglassHalf as proFasFaHourglassHalf,
  faHouse as proFasFaHouse,
  faKey as proFasFaKey,
  faMessage as proFasFaMessage,
  faRotateLeft as proFasFaRotateLeft,
  faShieldQuartered as proFasFaShieldQuartered,
  faTriangle as proFasFaTriangle,
  faUpLong as proFasFaUpLong,
  faXmark as proFasFaXmark
} from '@fortawesome/pro-solid-svg-icons'

import {
  faAngleLeft as proFarFaAngleLeft,
  faArrowLeft as proFarFaArrowLeft,
  faArrowRight as proFarFaArrowRight,
  faArrowUpRightFromSquare as proFarFaArrowUpRightFromSquare,
  faBallotCheck as proFarFaBallotCheck,
  faBarsFilter as proFarFaBarsFilter,
  faBell as proFarFaBell,
  faBorderAll as proFarFaBorderAll,
  faBuildingColumns as proFarFaBuildingColumns,
  faCaretLeft as proFarFaCaretLeft,
  faCaretRight as proFarFaCaretRight,
  faCheck as proFarFaCheck,
  faChevronRight as proFarFaChevronRight,
  faCircleCheck as proFarFaCircleCheck,
  faCircleChevronLeft as proFarFaCircleChevronLeft,
  faCircleChevronRight as proFarFaCircleChevronRight,
  faCircleExclamation as proFarFaCircleExclamation,
  faCircleInfo as proFarFaCircleInfo,
  faCirclePlus as proFarFaCirclePlus,
  faCircleQuestion as proFarFaCircleQuestion,
  faCircleUser as proFarFaCircleUser,
  faCircleXmark as proFarFaCircleXmark,
  faClock as proFarFaClock,
  faCopy as proFarFaCopy,
  faDownToLine as proFarFaDownToLine,
  faEdit as proFarFaEdit,
  faEllipsis as proFarFaEllipsis,
  faEmptySet as proFarFaEmptySet,
  faEnvelopeCircleCheck as proFarFaEnvelopeCircleCheck,
  faEnvelope as proFarFaEnvelope,
  faFaceSmile as proFarFaFaceSmile,
  faFaceFrown as proFarFaFaceFrown,
  faFileAlt as proFarFaFileAlt,
  faFileCheck as proFarFaFileCheck,
  faFileContract as proFarFaFileContract,
  faFileInvoiceDollar as proFarFaFileInvoiceDollar,
  faFileMagnifyingGlass as proFarFaFileMagnifyingGlass,
  faFilePdf as proFarFaFilePdf,
  faFileSearch as proFarFaFileSearch,
  faFileUpload as proFarFaFileUpload,
  faFile as proFarFaFile,
  faFilterCircleDollar as proFarFaFilterCircleDollar,
  faFolder as proFarFaFolder,
  faGaugeHigh as proFarFaGaugeHigh,
  faHexagonExclamation as proFarFaHexagonExclamation,
  faHourglassClock as proFarFaHourglassClock,
  faHourglassStart as proFarFaHourglassStart,
  faHouse as proFarFaHouse,
  faKey as proFarFaKey,
  faLightbulb as proFarFaLightbulb,
  faLockKeyhole as proFarFaLockKeyhole,
  faLock as proFarFaLock,
  faMessage as proFarFaMessage,
  faMoneyBill as proFarFaMoneyBill,
  faOctagonExclamation as proFarFaOctagonExclamation,
  faPencil as proFarFaPencil,
  faPenToSquare as proFarFaPenToSquare,
  faPhone as proFarFaPhone,
  faRefresh as proFarFaRefresh,
  faSackDollar as proFarFaSackDollar,
  faScrewdriverWrench as proFarFaScrewdriverWrench,
  faStar as proFarFaStar,
  faStopwatch as proFarFaStopwatch,
  faTimer as proFarFaTimer,
  faTrashAlt as proFarFaTrashAlt,
  faTrashCan as proFarFaTrashCan,
  faTrash as proFarFaTrash,
  faTriangleExclamation as proFarFaTriangleExclamation,
  faUserGear as proFarFaUserGear,
  faUserPlus as proFarFaUserPlus,
  faXmark as proFarFaXmark
} from '@fortawesome/pro-regular-svg-icons'

import {
  faBadgePercent as proFalFaBadgePercent,
  faBorderAll as proFalFaBorderAll,
  faCalendarDays as proFalFaCalendarDays,
  faChartLineUp as proFalFaChartLineUp,
  faChevronLeft as proFalFaChevronLeft,
  faCircleCheck as proFalFaCircleCheck,
  faCircleDollar as proFalFaCircleDollar,
  faCircleExclamation as proFalFaCircleExclamation,
  faCircleInfo as proFalFaCircleInfo,
  faEyeSlash as proFalFaEyeSlash,
  faEye as proFalFaEye,
  faFileInvoiceDollar as proFalFaFileInvoiceDollar,
  faFolder as proFalFaFolder,
  faHouse as proFalFaHouse,
  faKey as proFalFaKey,
  faLightbulb as proFalFaLightbulb,
  faMessage as proFalFaMessage,
  faMoneyFromBracket as proFalFaMoneyFromBracket,
  faPhone as proFalFaPhone,
  faSackDollar as proFalFaSackDollar,
  faScrewdriverWrench as proFalFaScrewdriverWrench,
  faSeedling as proFalFaSeedling,
  faShop as proFalFaShop,
  faUserGear as proFalFaUserGear,
  faUsers as proFalFaUsers
} from '@fortawesome/pro-light-svg-icons'

import {
  faCircleCheck as proFatFaCircleCheck
} from '@fortawesome/pro-thin-svg-icons'

import {
  faCircleXmark as sharpFasFaCircleXmark,
  faDownLong as sharpFasFaDownLong,
  faTriangle as sharpFasFaTriangle,
  faUpLong as sharpFasFaUpLong
} from '@fortawesome/sharp-solid-svg-icons'

export default {proFasFaAngleRight, proFasFaBan, proFasFaCheck, proFasFaChevronDown, proFasFaChevronRight, proFasFaCircleCheck, proFasFaCircleExclamation, proFasFaCircleInfo, proFasFaCircleX, proFasFaCircleXmark, proFasFaCircle, proFasFaDownLong, proFasFaEllipsisVertical, proFasFaFileContract, proFasFaHourglassClock, proFasFaHourglassHalf, proFasFaHouse, proFasFaKey, proFasFaMessage, proFasFaRotateLeft, proFasFaShieldQuartered, proFasFaTriangle, proFasFaUpLong, proFasFaXmark, proFarFaAngleLeft, proFarFaArrowLeft, proFarFaArrowRight, proFarFaArrowUpRightFromSquare, proFarFaBallotCheck, proFarFaBarsFilter, proFarFaBell, proFarFaBorderAll, proFarFaBuildingColumns, proFarFaCaretLeft, proFarFaCaretRight, proFarFaCheck, proFarFaChevronRight, proFarFaCircleCheck, proFarFaCircleChevronLeft, proFarFaCircleChevronRight, proFarFaCircleExclamation, proFarFaCircleInfo, proFarFaCirclePlus, proFarFaCircleQuestion, proFarFaCircleUser, proFarFaCircleXmark, proFarFaClock, proFarFaCopy, proFarFaDownToLine, proFarFaEdit, proFarFaEllipsis, proFarFaEmptySet, proFarFaEnvelopeCircleCheck, proFarFaEnvelope, proFarFaFaceSmile, proFarFaFaceFrown, proFarFaFileAlt, proFarFaFileCheck, proFarFaFileContract, proFarFaFileInvoiceDollar, proFarFaFileMagnifyingGlass, proFarFaFilePdf, proFarFaFileSearch, proFarFaFileUpload, proFarFaFile, proFarFaFilterCircleDollar, proFarFaFolder, proFarFaGaugeHigh, proFarFaHexagonExclamation, proFarFaHourglassClock, proFarFaHourglassStart, proFarFaHouse, proFarFaKey, proFarFaLightbulb, proFarFaLockKeyhole, proFarFaLock, proFarFaMessage, proFarFaMoneyBill, proFarFaOctagonExclamation, proFarFaPencil, proFarFaPenToSquare, proFarFaPhone, proFarFaRefresh, proFarFaSackDollar, proFarFaScrewdriverWrench, proFarFaStar, proFarFaStopwatch, proFarFaTimer, proFarFaTrashAlt, proFarFaTrashCan, proFarFaTrash, proFarFaTriangleExclamation, proFarFaUserGear, proFarFaUserPlus, proFarFaXmark, proFalFaBadgePercent, proFalFaBorderAll, proFalFaCalendarDays, proFalFaChartLineUp, proFalFaChevronLeft, proFalFaCircleCheck, proFalFaCircleDollar, proFalFaCircleExclamation, proFalFaCircleInfo, proFalFaEyeSlash, proFalFaEye, proFalFaFileInvoiceDollar, proFalFaFolder, proFalFaHouse, proFalFaKey, proFalFaLightbulb, proFalFaMessage, proFalFaMoneyFromBracket, proFalFaPhone, proFalFaSackDollar, proFalFaScrewdriverWrench, proFalFaSeedling, proFalFaShop, proFalFaUserGear, proFalFaUsers, proFatFaCircleCheck, sharpFasFaCircleXmark, sharpFasFaDownLong, sharpFasFaTriangle, sharpFasFaUpLong}